import { useMessage } from '@/hooks'
import { hasUserInfo, updateUserInfo } from '@/utils'
import { createLoading as createPageLoading } from '@/pages/loading/utils/index'
import Login from '@/components/login'
/**
 * 获取用户信息进行下一步
 */
function useUserInfoGuard(router) {
  router.beforeEach(async (to, from, next) => {
    // 非白名单 + 登录状态 + 未获取用户信息才回获取用户信息
    if (!to.meta.isNoAuth && Login.value.getToken() && !hasUserInfo()) {
      const clearLoading = createPageLoading()
      try {
        await updateUserInfo()
        return next()
      } catch(e) {
        return useMessage.message.error('获取用户信息失败')
      } finally {
        clearLoading()
      }
    }
    next()
  })
}

export default useUserInfoGuard

